import { Button, Card, Form, FormInstance, Modal, Radio, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import '../../../assets/styles/desktop/busBooking.scss';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { resetAssistBooking, setListFreeSeat } from '../../../redux/slice/bookings/getAssistBookingSlice';
import { getPriceScheduleReason } from '../../../utils/helpers';

const AssistBookingModal: React.FC<any> = ({ modalOpen, onCancel, onOk }) => {
  const { listAssistBooking, loading } = useAppSelector((state) => state.assistBooking);
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [formAssistBooking]: [FormInstance] = Form.useForm();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };
  const modalHandleCancel = () => {
    onCancel();
    formAssistBooking.resetFields();
    dispatch(resetAssistBooking());
  };

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formAssistBooking.scrollToField(firstErrorField.name);
    }
  };

  const onFinish = (values: any) => {
    const selectedSegment =
      listAssistBooking?.length && listAssistBooking?.find((booking: any) => booking.segment_id === values.segment_id);
    dispatch(
      setListFreeSeat({
        segment_name: `${selectedSegment?.start_location?.name} - ${selectedSegment?.end_location?.name}`,
        free_seats: selectedSegment?.free_seats,
        segment_id: selectedSegment?.segment_id,
        transship_depart: selectedSegment?.transship_depart,
        transship_arrive: selectedSegment?.transship_arrive,
      }),
    );
    onCancel();
    formAssistBooking.resetFields();
  };

  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      centered
      footer={[]}
      width={640}
      title={
        <div className="border-booking-title">
          <h3 className="fs-18 fw-600 text-middle-black">Hỗ trợ tìm kiếm chỗ để đặt vé</h3>
        </div>
      }
      maskClosable={false}
      className="modal-bus-booking"
    >
      <Spin spinning={loading}>
        <p className="fs-16 fw-500 text-blue mt-1">Chọn chặng bạn muốn đặt vé:</p>
        <Card className="card-modal-booking mt-1 assist">
          <Form
            layout="vertical"
            className="form-booking-multi"
            form={formAssistBooking}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            labelAlign={'left'}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
          >
            <div className="ticket-info-booking-block mt-2">
              <div className="bg-ticket">
                <span className="fs-16 fw-600">Danh sách các chặng</span>
              </div>
              <Form.Item
                name={'segment_id'}
                className="segment-item-block"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập chặng',
                  },
                ]}
              >
                <Radio.Group className="d-flex flex-col gap-y-12 payment-checkbox-group seat-available">
                  {listAssistBooking?.map((booking: any, index: number) => (
                    <Radio
                      value={booking?.segment_id}
                      key={index}
                      className="available-seat-block"
                      disabled={booking?.available_seats === 0}
                    >
                      <div className="available-seat-item">
                        <div>
                          <p>{`${booking?.start_location?.name} - ${booking?.end_location?.name}`}</p>
                          <p className="fs-13 text-success fw-500">
                            {getPriceScheduleReason(booking?.price_schedule, false)}
                          </p>
                        </div>
                        <div className="available-seat-segment fs-14 fw-600">Còn {booking?.available_seats} chỗ</div>
                      </div>
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </div>
            <Row className="d-flex justify-content-end mt-3 w-100" style={{ columnGap: '10px' }}>
              <>
                <Button
                  key="cancel"
                  className="w-200 h-btn-44 btn-back fs-16 fw-600 t-b rounded-lg"
                  // loading={loading}
                  htmlType="button"
                  onClick={() => modalHandleCancel()}
                >
                  Đóng
                </Button>
                <Button
                  key="submit"
                  className=" w-200 h-btn-44 btn-success text-white fs-16 fw-600 rounded-lg mr-8"
                  htmlType="submit"
                  onClick={() => modalHandleOk()}
                >
                  Gợi ý chọn chỗ
                </Button>
              </>
            </Row>
          </Form>
        </Card>
      </Spin>
    </Modal>
  );
};
export default AssistBookingModal;
